import { render, staticRenderFns } from "./StylistWithRating.vue?vue&type=template&id=0a688f40&scoped=true&"
import script from "./StylistWithRating.vue?vue&type=script&lang=js&"
export * from "./StylistWithRating.vue?vue&type=script&lang=js&"
import style0 from "./StylistWithRating.vue?vue&type=style&index=0&id=0a688f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a688f40",
  null
  
)

export default component.exports